import inputValidation from 'actions/inputValidation';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductValidationModal from './ProductValidationModal';
import { PRODUCT_IDENITFIER_MAP } from 'constants/constants';
import { SINGLE_UPLOAD_PAYLOAD_UPDATE_SUCCESS } from 'constants/actionTypes';
import ConfirmationAlertBox from 'componentsV2/SharedAlertBox/ConfirmationAlertBox/ConfirmationAlertBox';
import { productValidationService } from 'api/productValidationService';
import AlertBox from 'componentsV2/SharedAlertBox/AlertBox/AlertBox';
import { targetsiteErp } from 'actions/targetsiteErpMapping';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';

const ProductValidation = () => {
  const { eventType, fieldId, value, rowIndex } = useSelector(
    (state: any) => state.inputValidationReducer
  );
  const dispatch: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [productList, setProductList] = useState<any[]>([]);
  const singleUploadPayload = useSelector(
    (state: any) => state.singleUpload.payload
  );
  const [confirmationAlert, setConfirmationAlert] = useState({ isOpen: false });
  const [alert, setAlert] = useState({ isModalOpen: false, message: '' });
  const dropdownOptionsState = useSelector(
    (state: any) => state.dropdownOptionsReducer?.dropdownOptions
  );
  const message =
    'Product not found, If it a custom SKU then please enter the product details in the fields.';

  const getTargetSite = (code: string) => {
    if(code===''){
      return '';
    }
    const targetSiteOptions = dropdownOptionsState?.tfs_target_site_lu || [];
    const site = targetSiteOptions.find((option: any) => option.value === code);
    const text = site.description;
    // site.description === site.value
    //   ?   site.description
    //   : `${site.description} [ ${site.value} ]`;
    return text;
  };

  const getValues = (
    previousValues: any,
    selectedProducts: any,
    mappingId: keyof typeof PRODUCT_IDENITFIER_MAP
  ) => {
    const id = PRODUCT_IDENITFIER_MAP[mappingId];
    const values = selectedProducts.map((product: any) => {
      return {
        id:
          id === 'webId'
            ? product.webId
              ? product.webId
              : product.fcatNum
            : product[id],
        display_value:
          id === 'webId'
            ? product.webId
              ? product.webId
              : product.fcatNum
            : id === 'targetSite'
              ? getTargetSite(product[id])
              : product[id]
      };
    });
    previousValues[rowIndex || 0] = values[0];
    return [...previousValues, ...values.slice(1)];
  };

  const updateProductIdentifiers = (selectedProducts: any) => {
    // Update the Redux store with the selected products
    const currentState = { ...singleUploadPayload };
    const result = currentState?.metadata_collection?.metadata_element_list
      ?.find((obj: any) => obj.id === 'TFS.CATEGORY.PRODUCT_IDENTIFIERS')
      .metadata_element_list.map((field: any) => {
        field.values = getValues(
          field.values,
          selectedProducts,
          field.field_id
        );
        return field;
      });
    const updatedPayload = {
      ...singleUploadPayload,
      metadata_collection: {
        ...singleUploadPayload.metadata_collection,
        metadata_element_list: singleUploadPayload?.metadata_collection?.metadata_element_list.map(
          (obj: any) => {
            if (obj.id === 'TFS.CATEGORY.PRODUCT_IDENTIFIERS') {
              return {
                ...obj,
                metadata_element_list: result
              };
            }
            return obj;
          }
        )
      }
    };

    // Dispatch the updated payload to the Redux store
    dispatch({
      type: SINGLE_UPLOAD_PAYLOAD_UPDATE_SUCCESS,
      payload: updatedPayload
    });
    // clear the state
    dispatch(inputValidation({ eventType: '', fieldId: '', value: '' }));
  };

  const handleAction = (action: string, selectedProducts: object) => {
    if (action === 'YES') {
      updateProductIdentifiers(selectedProducts);
    } else {
      // clear the state
      dispatch(inputValidation({ eventType: '', fieldId: '', value: '' }));
    }
    setIsModalOpen(false);
    setProductList([]);
  };

  const clearRow = (
    mappingId: keyof typeof PRODUCT_IDENITFIER_MAP,
    action: string
  ) => {
    const id = PRODUCT_IDENITFIER_MAP[mappingId];
    const selectedProducts = [
      {
        description: '',
        erp: '',
        fcatNum: '',
        gid: '',
        labelCode: '',
        mpn: id === 'mpn' ? value : '',
        productName: '',
        productTitle: '',
        rootSku: id === 'rootSku' ? value : '',
        targetSite: '',
        vendorName: '',
        vnum: '',
        webId: id === 'webId' ? value : '',
        isCustom: action === 'YES' ? 'Y' : 'N'
      }
    ];
    updateProductIdentifiers(selectedProducts);
  };

  const handleCustomSku = (action: string) => {
    if (action === 'YES') {
      setConfirmationAlert({ isOpen: false });
      clearRow(fieldId, 'YES');
    } else {
      setConfirmationAlert({ isOpen: false });
      clearRow(fieldId, 'NO');
    }
  };

  const validateSKU = async (skuId: string) => {
    // Call the validation API
    try {
      dispatch({ type: 'LOADING SUCCESS', payload: true });
      const response: any = await productValidationService
        .validateProduct({
          skuId: skuId,
          vendorNumber: null
        })
        .then((res) => {
          return res.json();
        });
      dispatch({ type: 'LOADING SUCCESS', payload: false });
      if (!response || response?.message || response?.error) {
        setAlert({
          message: response?.message || 'Unable to validate SKU',
          isModalOpen: true
        });
        return;
      }
      if (response?.length === 0) {
        // custom sku scenario
        setConfirmationAlert({ isOpen: true });
      } else if (response?.length === 1) {
        // if only one product is found, update the payload
        updateProductIdentifiers(response);
      } else if (response?.length > 1) {
        setProductList(response);
        setIsModalOpen(true);
      }
    } catch (error: any) {
      console.error('Error calling validation API:', error);
      dispatch({ type: 'LOADING SUCCESS', payload: false });
      setAlert({
        message: error || 'Unable to validate SKU',
        isModalOpen: true
      });
    }
  };

  useEffect(() => {
    if (
      eventType &&
      eventType === 'blur' &&
      (fieldId === 'TFS.FIELD.WEB_ID' ||
        fieldId === 'TFS.FIELD.MPN' ||
        fieldId === 'TFS.FIELD.ROOT_SKU') &&
      value
    ) {
      // Call the validation API
      validateSKU(value);
    }
  }, [dispatch, eventType, fieldId, value]);

  useEffect(() => {
    dispatch(targetsiteErp.targetsiteErpMappings());
  }, []);

  const handleClose = () => {
    setAlert({ isModalOpen: false, message: '' });
    // clear the state
    dispatch(inputValidation({ eventType: '', fieldId: '', value: '' }));
  };

  return (
    <>
      <ProductValidationModal
        isModalOpen={isModalOpen}
        productList={productList}
        handleAction={handleAction}
        message=""
      />
      {confirmationAlert?.isOpen && (
        <ConfirmationAlertBox
          isModalOpen={confirmationAlert?.isOpen}
          header="Confirm"
          message={message}
          handleAction={handleCustomSku}
        />
      )}
      {alert.isModalOpen && (
        <AlertBox
          isModalOpen={alert.isModalOpen}
          message={alert.message}
          handleClose={handleClose}
        />
      )}
    </>
  );
};

export default ProductValidation;
